import { resolveMediaUrl } from '../../salon-admin/utils/mediaUrl';
import { readStoredFranchiseBrandLogo } from '../../shared/franchiseBrand';

export function resolveLogoUrl(raw) {
  return resolveMediaUrl(raw) || '';
}

/** Franchise outlet logo for kiosk customer flows (not HQ org / portal logo). */
export function readStoredOrgLogo() {
  return readStoredFranchiseBrandLogo();
}
